export default "__VITE_ASSET__Dmf3gbGY__"